module.exports = __webpack_public_path__ + "img/erweima.18c3bca0.png";